import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { getMonthlyStatement } from '../../../../../../CBSA_App/api/getEntrySummaryData';

const columns = [
  'Document Type',
  'Port',
  'Transaction',
  'Importer',
  'K84 Date',
  'Duty',
  'Sima',
  'GST',
  'Excise',
  'Penalty/\nInterest',
  'Total',
];

function getLastAndCurrentMonthEpochs() {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const lastMonth = currentMonth === 1 ? 12 : currentMonth - 1;
  const lastMonthDate = new Date(`${currentYear}-${lastMonth}-25`);
  const currentMonthDate = new Date(`${currentYear}-${currentMonth}-24`);
  const lastMonthEpoch = lastMonthDate.getTime();
  const currentMonthEpoch = currentMonthDate.getTime();
  return {
    lastMonthEpoch,
    currentMonthEpoch,
  };
}

function getEpochs(monthYearString) {
  const [year, month] = monthYearString.split('-').map(Number);
  const currentMonthEpoch = new Date(year, month - 1, 24).getTime();
  const lastMonthEpoch = new Date(year, month - 2, 25).getTime();
  return { currentMonthEpoch, lastMonthEpoch };
}

function epochToLocalDateString(epochTime) {
  const date = new Date(epochTime);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  return date.toLocaleDateString(undefined, options);
}
const MonthlyStatements = (props) => {
  const [statementsData, setStatementsData] = useState([]);
  const { lastMonthEpoch, currentMonthEpoch } =
    props.selectedMonth == null
      ? getLastAndCurrentMonthEpochs()
      : getEpochs(props.selectedMonth);
  let lastMonthDate = epochToLocalDateString(lastMonthEpoch);
  let currentMonthDate = epochToLocalDateString(currentMonthEpoch);
  useEffect(() => {
    getMonthlyStatement(lastMonthEpoch, currentMonthEpoch).then((res) => {
      setStatementsData(res.data.eventMessage?.dailyStatementDetails);
    });
  }, [props.selectedMonth]);

  function calculateTotals(dailyStatementDetails) {
    let dutyTotal = 0;
    let simaTotal = 0;
    let gstTotal = 0;
    let exciseTotal = 0;
    let b3GrandTotal = 0;
    let penaltyTotal = 0;
    if (dailyStatementDetails && dailyStatementDetails.length) {
      dailyStatementDetails.forEach((dailyStatement) => {
        if (
          dailyStatement.statementEntries &&
          dailyStatement.statementEntries.length
        ) {
          dailyStatement.statementEntries.forEach((entry) => {
            dutyTotal += parseFloat(entry.duty);
            simaTotal += parseFloat(entry.sima);
            gstTotal += parseFloat(entry.gst);
            exciseTotal += parseFloat(entry.excise);
            b3GrandTotal += parseFloat(entry.b3Total);
          });
        }
      });
    }
    return {
      dutyTotal,
      simaTotal,
      gstTotal,
      exciseTotal,
      b3GrandTotal,
      penaltyTotal
    };
  }

  let grandTotals = calculateTotals(statementsData);

  return (
    <div
    className='monthlystmt'
    // style={{ overflowY: 'scroll', textAlign: 'center', height:'500px'}}
    >
      <div>
        <h3>DN Report</h3>
      </div>
      <span style={{ marginRight: 20 }}>Start Date : {lastMonthDate}</span>
      <span style={{ marginLeft: 20 }}>End Date : {currentMonthDate}</span>
      <Table celled>
        <Table.Header>
          <Table.Row>
            {columns.map((column) => (
              <Table.HeaderCell
                key={column}
                style={{
                  textAlign: 'center',
                  zIndex: 10,
                  width:
                    column == 'K84 Date'
                      ? '30%'
                      : column == 'Importer'
                      ? '60%'
                      : '',
                }}
              >
                {column}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {statementsData?.map(({ importerName, DN_DATE, statementEntries }) =>
            statementEntries?.map(
              ({
                transactionNumber,
                docType,
                Port,
                duty,
                sima,
                excise,
                gst,
                b3Total,
              }) => (
                <Table.Row key={transactionNumber}>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    {docType}
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    {Port}
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    {transactionNumber}
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    {importerName}
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    {DN_DATE}
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    {duty}
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    {sima}
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>{gst}</Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    {excise}
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    0.00
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    {b3Total}
                  </Table.Cell>
                </Table.Row>
              )
            )
          )}
          <Table.Row key={'GrandTotal'}>
            <Table.Cell style={{ textAlign: 'center' }}></Table.Cell>
            <Table.Cell style={{ textAlign: 'center' }}></Table.Cell>
            <Table.Cell style={{ textAlign: 'center' }}></Table.Cell>
            <Table.Cell style={{ textAlign: 'center' }}></Table.Cell>
            <Table.Cell style={{ textAlign: 'center' }}>Grand Total</Table.Cell>
            <Table.Cell style={{ textAlign: 'center' }}>
              {grandTotals?.dutyTotal.toFixed(2)}
            </Table.Cell>
            <Table.Cell style={{ textAlign: 'center' }}>
              {grandTotals?.simaTotal.toFixed(2)}
            </Table.Cell>
            <Table.Cell style={{ textAlign: 'center' }}>
              {grandTotals?.gstTotal.toFixed(2)}
            </Table.Cell>
            <Table.Cell style={{ textAlign: 'center' }}>
              {grandTotals?.exciseTotal.toFixed(2)}
            </Table.Cell>
            <Table.Cell style={{ textAlign: 'center' }}>
              {grandTotals?.penaltyTotal.toFixed(2)}
            </Table.Cell>
            <Table.Cell style={{ textAlign: 'center' }}>
              {grandTotals?.b3GrandTotal.toFixed(2)}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
};

export default MonthlyStatements;
